import 'bootstrap';
import '../vendor/slick/slick.min';
import '../vendor/fancybox/dist/jquery.fancybox.min';
import './Cookies.es5';
import './cart';
import './main';